@if (isReadOnly) {
  <div
    class="w-full h-[30px] text-xs theme-text-3 flex items-center justify-center theme-bg-warning"
    [attr.aria-label]="aria"
  >
    <span matTooltip="{{ toolTip }}">{{ message }}</span>
  </div>
}
